import { getQuestionScrollerComponents } from './selector'

export const QuestionScroller = (() => {
	const scrollQuestions = (lastQuestion: boolean) => {
		const { questionsContainer } = getQuestionScrollerComponents()

		if (questionsContainer === null) {
			return
		}

		let scrollElement: Element | null = null
		if (lastQuestion) {
			scrollElement = questionsContainer.lastElementChild
		} else {
			scrollElement = questionsContainer.querySelector('.js-sortable-row > div.bg-primary')
		}

		if (scrollElement === null) {
			return
		}

		scrollElement.scrollIntoView(false)
	}

	const initScroller = () => {
		$.nette.ext('questionScroller', {
			complete: (jqXHR: any) => {
				scrollQuestions(jqXHR.scrollQuestionsContainer === true)
			},
		})
	}

	const init = (isAjax: boolean) => {
		if (isAjax) {
			scrollQuestions(false)
			return
		}

		window.addEventListener('load', () => {
			scrollQuestions(false)
		})

		initScroller()
	}

	return {
		init,
	}
})()
